export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00557.a4c70d0a.png";